/*
 * @Author: qinqianwen
 * @Date: 2020-08-04 09:15:55
 * @LastEditTime: 2020-08-11 17:11:19
 * @LastEditors: sunxiaodong
 * @Description: 字典管理模块api
 * @FilePath: \e6-module-base-data\src\e6-module-base-data\api\dictionaryManage.js
 */
import http from "e6-base-core/axios/config";
import { e6ModuleBaseDataApi } from "@/config/api";
const { host = "", E6_MS_TMS_E6YUN_BASE_WEB = "" } = e6ModuleBaseDataApi;

//分页获取字典表格数据
export function fetchDictionaryList(data) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/baseDictionary/getPageByCondition`,
    method: "post",
    data
  });
}
//新增用户字典
export function addDictionary(data) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/baseDictionary/insertDictionary`,
    method: "post",
    data
  });
}
//根据id查详细信息
export function getDictionaryById(params) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/baseDictionary/getDictionaryById`,
    method: "get",
    params
  });
}
//修改用户字典
export function updateDictionary(data) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/baseDictionary/modifyDictionary`,
    method: "post",
    data
  });
}
//获取类型名称下拉数据
export function getDicTypeNameList() {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/baseDictionary/getTypeNameList`,
    method: "get"
  });
}
//校验类型名称唯一性
export function checkTypeNameUnicode(data) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/baseDictionary/checkDicName`,
    method: "post",
    data
  });
}
//根据key值查字典下拉
export function fetchByDicTypeKey(params) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/baseDictionary/findByDicTypeKey`,
    method: "get",
    params
  });
}
